import * as React from 'react';
import { SVGProps } from 'react';

const ChatModeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <g fill="#343330">
      <path d="M21 9v12l-3.71-3H8.25a.75.75 0 0 1-.75-.75V13.5h8.25a.75.75 0 0 0 .75-.75v-4.5h3.75A.75.75 0 0 1 21 9Z" opacity={0.2} />
      <path d="M20.25 7.5h-3v-3a1.5 1.5 0 0 0-1.5-1.5h-12a1.5 1.5 0 0 0-1.5 1.5v12a.75.75 0 0 0 1.219.583l3.281-2.645v2.812a1.5 1.5 0 0 0 1.5 1.5h8.774l3.507 2.833a.75.75 0 0 0 1-.053.75.75 0 0 0 .219-.53V9a1.5 1.5 0 0 0-1.5-1.5ZM6.24 12.917 3.75 14.93V4.5h12v8.25H6.71a.75.75 0 0 0-.47.167Zm14.01 6.513-2.49-2.013a.75.75 0 0 0-.468-.167H8.25v-3h7.5a1.5 1.5 0 0 0 1.5-1.5V9h3v10.43Z" />
    </g>
  </svg>
);
export default ChatModeIcon;
